export default __webpack_public_path__ + "static/media/bitmoji.45ac7e06.svg";